import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import {
  IBillingCycle,
  ProductsSubprojectService,
} from 'src/app/services/products-subproject/products-subproject.service';
import { SpinnerService } from '../../../../../../services/spinner/spinner.service';
import {
  VendorProduct,
  VendorProductsService,
} from '../../../../../../services/vendorproducts/vendorproducts.service';
import { BaseResponse } from 'src/app/interfaces/base-response-interface';

@Component({
  selector: 'app-vendor-product-details',
  templateUrl: './vendor-product-details.component.html',
  styleUrls: ['./vendor-product-details.component.scss'],
})
export class VendorProductDetailsComponent implements OnInit {
  public product!: VendorProduct;
  public billingCycles: IBillingCycle[] = [];
  public stripeProductTabDisabled = true;
  public selectedTabIndex = 0;
  public subProjectProductId: string = '';

  constructor(
    private readonly vendorProductsService: VendorProductsService,
    private readonly productsSubprojectService: ProductsSubprojectService,
    private readonly spinnerService: SpinnerService,
    private readonly snackBar: MatSnackBar,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      this.spinnerService.show();
      try {
        await this.getBillingCycles();
        if (params['productId']) {
          await this.getProduct(params['productId']);
        }
      } catch (err) {
        console.error(err);
        this.snackBar.open('Error loading vendor product details', 'Error', {
          duration: 2000,
        });
      } finally {
        this.spinnerService.hide();
      }
    });
  }

  private async getBillingCycles(): Promise<void> {
    const billingCyclesResponse = await this.productsSubprojectService.getBillingCycles();
    if (billingCyclesResponse.success) {
      this.billingCycles = billingCyclesResponse.data;
      return;
    }
    this.snackBar.open('Error loading billing cycles', 'Error', {
      duration: 2000,
    });
  }

  public productSavedHandler(): void {
    this.snackBar.open('Product details updated successfully', 'Success', { duration: 3000 });
    this.getProduct(this.product.id);
  }

  public disabeStripeProductTab(): void {
    this.stripeProductTabDisabled = true;
    this.selectedTabIndex = 0;
  }

  private async getProduct(productId: string): Promise<void> {
    const productResponse = await this.vendorProductsService.getVendorProductById(productId);
    const product = this.unwrapVendorProductResponse(productResponse);
    if (!product) {
      this.snackBar.open('Vendor product details not found', 'Error', {
        duration: 2000,
      });
      return;
    }

    this.product = product;
    this.stripeProductTabDisabled = !this.product.stripeProductId;
  }

  public onProductIdChanged(productId: string): void {
    this.subProjectProductId = productId;
  }

  private unwrapVendorProductResponse(
    response: BaseResponse<VendorProduct> | VendorProduct | null | undefined,
  ): VendorProduct | null {
    if (!response) {
      return null;
    }

    if ('success' in response) {
      return response.success ? response.data : null;
    }

    return response;
  }
}
